import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import WithCurrentUser from '../../../CurrentUser/Context/WithCurrentUser';
import EventsStore from '../../../EventsStore';
import TeamStore from '../../../TeamStore';
import TeamReactions from '../../../TeamStore/TeamReactions';
import { TPlainTextKey } from '../../../Translations';
import Events from './Events';

interface Props {
  eventsStore: EventsStore;
  header: TPlainTextKey;
  headingLevel: 2 | 3;
  teamId: Maybe<number>;
}

class TeamEvents extends React.Component<Props, {}> {
  teamStore: TeamStore;

  constructor(props: Props) {
    super(props);
    this.teamStore = new TeamStore();
  }

  componentDidMount() {
    this.teamStore.loading();
  }

  render() {
    const { headingLevel, header, eventsStore, teamId } = this.props;
    return (
      <WithCurrentUser
        children={(currentUserResource) => (
          <>
            <Events
              eventsStore={eventsStore}
              header={header}
              headingLevel={headingLevel}
              linkable={this.teamStore}
            />
            <TeamReactions
              store={this.teamStore}
              teamId={teamId}
              currentUserResource={currentUserResource}
            />
          </>
        )}
      />
    );
  }
}

export default observer(TeamEvents);
